import { AgencyTaskSchema } from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postsKeys } from '@/queries/posts/keys';
import { apiClient } from '@/stores/api/apiClient';
import { postTasksKeys } from './keys';

export function useCreatePostTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: Partial<AgencyTaskSchema> & { postId: string; title: string }) => {
      return apiClient.post<ApiResponse<AgencyTaskSchema>>('/v1/agency_tasks', params);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: postsKeys.item(variables.postId) });
      queryClient.invalidateQueries({ queryKey: postTasksKeys.all });
    },
  });
}
